import { ObjectID } from 'bson';
import { providersEnglishNames } from '../constants';

interface IConstantSourceData {
  _id: ObjectID;
  name: string;
  user: ObjectID;
}

export const zomatoSource: IConstantSourceData = {
  _id: new ObjectID('5bb5ca9d02334868aa1f3a18'),
  name: providersEnglishNames.zomato,
  user: new ObjectID('5bb5ca9df28cf2ea614b0a70'),
};
export const pleaseSource: IConstantSourceData = {
  _id: new ObjectID('5bb64bdb32a52703c1c27a27'),
  name: providersEnglishNames.please,
  user: new ObjectID('5c1367b91403f943d958aa82'),
};
export const coralSource: IConstantSourceData = {
  _id: new ObjectID('5bb5f757b09a8472cf928c6d'),
  name: providersEnglishNames.coral,
  user: new ObjectID('5bb5f757411b29f575bf51e5'),
};
export const leezairSource: IConstantSourceData = {
  _id: new ObjectID('5bdb9ec83e93a65830f709c6'),
  name: providersEnglishNames.leezair,
  user: new ObjectID('5bdb9ed14760e950fb080674'),
};
export const customSource: IConstantSourceData = {
  _id: new ObjectID('5c98b83a1b62f335cbbd3b98'),
  name: providersEnglishNames.custom,
  user: new ObjectID('5c1367b91403f943d958aa82'),
};
export const yelpSource: IConstantSourceData = {
  _id: new ObjectID('5ca38a14730e95800f8a11af'),
  name: providersEnglishNames.yelp,
  user: new ObjectID('5ca3898df9a2a84d572db366'),
};
